import type { AxiosError } from 'axios';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { getMedicationsV3Url } from 'src/app/client/api';
import * as actionTypes from 'src/app/state/actions/types';
import type { Dispatch, RootState } from 'src/app/state/store';
import { extractErrorCodes } from 'src/app/utils';

import { segmentTrack } from '.';

export function requestMedicationsByName(medicationName) {
  return {
    type: actionTypes.REQUEST_MEDICATIONS_BY_NAME,
    medicationName,
  };
}

export function receiveMedicationsByName(medicationName, items) {
  return {
    type: actionTypes.RECEIVE_MEDICATIONS_BY_NAME,
    medicationName,
    items,
  };
}

export function inputFieldFocused(medIndex) {
  return {
    type: actionTypes.INPUT_FIELD_FOCUSED,
    medIndex,
  };
}

export function inputFieldBlur(medIndex) {
  return {
    type: actionTypes.INPUT_FIELD_BLUR,
    medIndex,
  };
}

export function fetchCatchedMedicationsByName(medicationName) {
  return async (_dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();

    const { transferMedications } = state;

    if (medicationName in transferMedications) {
      return transferMedications[medicationName];
    }
    return;
  };
}

export function searchForMedications(searchTerm: string, zipCode?: string) {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(requestMedicationsByName(searchTerm));
    const state = getState();
    const { client } = state;

    const zip = zipCode || state.facility?.address?.zipCode || state.account.data?.zipCode;

    try {
      const { data } = await client.getMedicationsV3(searchTerm, zip);

      const payload = {
        medications: data.map(medication => ({
          ...medication,
          dosage: medication.dosage ?? '',
        })),
      };

      if (payload.medications.length == 0) {
        dispatch(segmentTrack(UNIFIED.viewNoResultsTransferForm, { input: searchTerm }));
      }

      return dispatch(receiveMedicationsByName(searchTerm, payload));
    } catch (error) {
      const bffError = error as AxiosError;
      const title = bffError?.name ?? '-Unknown-';
      const flavorText = bffError?.response?.data?.flavorText ?? '-Unknown-';

      const api = getMedicationsV3Url(searchTerm, zip);
      const trackErrorPayload = {
        errorMessage: bffError.message,
        errorSummary: `Title: ${title} | Flavor Text: ${flavorText}`,
        api,
        errorCode: extractErrorCodes(bffError),
        source: window.location.href,
      };

      segmentTrack(UNIFIED.error, trackErrorPayload);
      throw error;
    }
  };
}

export function setMedicationLoadingState(patientMedicationId, isLoading) {
  return {
    type: actionTypes.SET_MEDICATION_LOADING_STATE,
    patientMedicationId,
    isLoading,
  };
}
